import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { PlatformContextService } from '../../services';

/**
 * Generated class for the PlatformContextDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[platformContext]'
})
export class PlatformContextDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private platformContextService: PlatformContextService
  ) { }

  @Input()
  set platformContext(context: string) {
    this.display(context);
  }

  private display(context: string) {
    if (this.platformContextService.getPlatformContext() !== context && context !== 'all') {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/directives/platform-context/platform-context.ts